export default { sha: '679bf7658da7c723be2517e841b148356bdaa03b', buildNumber: 'undefined' }
